<div class="content">
  <app-location-manager-page
    [managing]="false"
    [title]="data?.title"
    [preloadedLocation]="data?.preloadedLocation"
    (cancel)="close()"
    (selectLocation)="select($event)"
  ></app-location-manager-page>
</div>
